import styled from "styled-components";

const SvgTitle = () => (
  <svg width="92" height="93" viewBox="0 0 92 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="46" cy="46.6152" r="46" fill="#F2F4FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.3508 21.2431C36.7202 20.981 37.146 20.8421 37.5803 20.8418H42.2595C42.6938 20.8421 43.1195 20.981 43.489 21.2431C43.8584 21.5052 44.1569 21.8801 44.351 22.3258L46.0449 26.209H53.9573C54.5777 26.209 55.1728 26.4918 55.6116 26.995C56.0503 27.4983 56.2968 28.1809 56.2968 28.8926C56.2968 29.6044 56.0503 30.287 55.6116 30.7902C55.1728 31.2935 54.5777 31.5763 53.9573 31.5763V50.2994C52.2352 50.9346 50.6531 51.9383 49.3303 53.261C46.9271 55.6642 45.577 58.9236 45.577 62.3223C45.577 62.8116 45.605 63.2981 45.6601 63.7796H30.5616C29.3207 63.7796 28.1305 63.2141 27.253 62.2076C26.3755 61.201 25.8825 59.8359 25.8825 58.4124V31.5763C25.262 31.5763 24.667 31.2935 24.2282 30.7902C23.7895 30.287 23.543 29.6044 23.543 28.8926C23.543 28.1809 23.7895 27.4983 24.2282 26.995C24.667 26.4918 25.262 26.209 25.8825 26.209H33.7949L35.4888 22.3258C35.6829 21.8801 35.9814 21.5052 36.3508 21.2431ZM53.9573 58.137V58.4124C53.9573 58.9091 53.8972 59.3987 53.7818 59.8684C53.665 59.6402 53.6035 59.3853 53.6058 59.1244C53.6089 58.7635 53.7338 58.4161 53.9573 58.137ZM33.5865 35.0459C33.1477 35.5492 32.9012 36.2317 32.9012 36.9435V53.0452C32.9012 53.7569 33.1477 54.4395 33.5865 54.9428C34.0252 55.446 34.6203 55.7288 35.2408 55.7288C35.8613 55.7288 36.4563 55.446 36.8951 54.9428C37.3338 54.4395 37.5803 53.7569 37.5803 53.0452V36.9435C37.5803 36.2317 37.3338 35.5492 36.8951 35.0459C36.4563 34.5426 35.8613 34.2599 35.2408 34.2599C34.6203 34.2599 34.0252 34.5426 33.5865 35.0459ZM42.9447 35.0459C43.3834 34.5426 43.9785 34.2599 44.599 34.2599C45.2195 34.2599 45.8146 34.5426 46.2533 35.0459C46.6921 35.5492 46.9386 36.2317 46.9386 36.9435V53.0452C46.9386 53.7569 46.6921 54.4395 46.2533 54.9428C45.8146 55.446 45.2195 55.7288 44.599 55.7288C43.9785 55.7288 43.3834 55.446 42.9447 54.9428C42.5059 54.4395 42.2595 53.7569 42.2595 53.0452V36.9435C42.2595 36.2317 42.5059 35.5492 42.9447 35.0459Z"
      fill="#6C8EF8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.3911 72.3897C61.0605 72.3897 63.6206 71.3293 65.5081 69.4417C67.3957 67.5542 68.4561 64.9941 68.4561 62.3247C68.4561 59.6553 67.3957 57.0953 65.5081 55.2077C63.6206 53.3202 61.0605 52.2598 58.3911 52.2598C55.7217 52.2598 53.1617 53.3202 51.2741 55.2077C49.3866 57.0953 48.3262 59.6553 48.3262 62.3247C48.3262 64.9941 49.3866 67.5542 51.2741 69.4417C53.1617 71.3293 55.7217 72.3897 58.3911 72.3897ZM56.7644 58.919C56.5271 58.6898 56.2093 58.563 55.8794 58.5659C55.5495 58.5687 55.234 58.701 55.0007 58.9343C54.7675 59.1676 54.6351 59.4831 54.6323 59.813C54.6294 60.1429 54.7562 60.4607 54.9854 60.698L56.6121 62.3247L54.9854 63.9515C54.8652 64.0675 54.7694 64.2063 54.7034 64.3598C54.6375 64.5133 54.6028 64.6784 54.6014 64.8455C54.5999 65.0125 54.6317 65.1782 54.695 65.3328C54.7583 65.4874 54.8517 65.6279 54.9698 65.746C55.0879 65.8642 55.2284 65.9576 55.383 66.0208C55.5376 66.0841 55.7033 66.1159 55.8704 66.1145C56.0374 66.113 56.2025 66.0783 56.356 66.0124C56.5095 65.9465 56.6483 65.8506 56.7644 65.7304L58.3911 64.1037L60.0179 65.7304C60.2552 65.9596 60.573 66.0864 60.9028 66.0836C61.2327 66.0807 61.5483 65.9484 61.7815 65.7151C62.0148 65.4819 62.1471 65.1663 62.15 64.8364C62.1528 64.5065 62.026 64.1887 61.7968 63.9515L60.1701 62.3247L61.7968 60.698C62.026 60.4607 62.1528 60.1429 62.15 59.813C62.1471 59.4831 62.0148 59.1676 61.7815 58.9343C61.5483 58.701 61.2327 58.5687 60.9028 58.5659C60.573 58.563 60.2552 58.6898 60.0179 58.919L58.3911 60.5457L56.7644 58.919Z"
      fill="#B8C3E9"
    />
  </svg>
);

const StyledSection = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    @media screen and (max-width: 1280px) {
      margin: 2rem 0 0 0;
    }
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
    @media screen and (max-width: 768px) {
      text-align: left;
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const SubHero = () => {
  return (
    <StyledSection>
      <StyledWrapper>
        <SvgTitle />
        <h2>Wipe all your content with a few clicks</h2>
        <p>
          Redact can automatically clean up all your posts, tweets, messages or DM&apos;s while you
          sit back and relax. Bulk delete everything or only remove certain messages. Its up to you!
        </p>
      </StyledWrapper>
    </StyledSection>
  );
};

export default SubHero;
